$('input[name=select_all]').on('change', ({ target }) => {
  const name = $(target).data('name').replaceAll(/([\[\]])/g, '\\$1');
  const startWith = $(target).data('start-with');
  const selector = $(target).data('selector') || `input[name${startWith ? '*' : ''}=${name}]`;
  $(selector).prop('checked', $(target).is(':checked'))
})
